export const RESERVATION_REQUEST = "RESERVATION_REQUEST";
export const RESERVATION_FAILED_REQUEST = "RESERVATION_FAILED_REQUEST";
export const RES_LOADING_REQUEST = "RES_LOADING_REQUEST";
export const RES_LOCATION_LIST = "RES_LOCATION_LIST";
export const RES_LOCATION_LIST_REQUEST = "RES_LOCATION_LIST_REQUEST";
export const RESERVATION_PRICING_LIST = "RESERVATION_PRICING_LIST";

export const RESERVATION_REQUEST_SUCEESS = "RESERVATION_REQUEST_SUCEESS";

export const RESERVATION_REQUEST_FAILED = "RESERVATION_REQUEST_FAILED";

export const UPDATE_RESERVATION_CHECKOUT = "UPDATE_RESERVATION_CHECKOUT";

export const RESERVATION_DETAILS = "RESERVATION_DETAILS";
export const AVAILABILITY_SUMMARY = "AVAILABILITY_SUMMARY";
export const SPOT_THRESHOLD = "SPOT_THRESHOLD";

export const RESERVATION_LIST_DATA = "RESERVATION_LIST_DATA";

export const EXTEND_RESERVATION_SUCCESS = "EXTEND_RESERVATION_SUCCESS";

export const CANCEL_RESERVATION_SUCCESS = "CANCEL_RESERVATION_SUCCESS";
export const CANCEL_RESERVATION_FAILED = "CANCEL_RESERVATION_FAILED";

export const SCHEDULE_MOVE_OUT_SUCCESS = "SCHEDULE_MOVE_OUT_SUCCESS";
export const SCHEDULE_MOVE_OUT_FAILURE = "SCHEDULE_MOVE_OUT_FAILURE";

export const FETCH_CALCULATED_PRICE_REQUEST = "FETCH_CALCULATED_PRICE_REQUEST";
export const FETCH_CALCULATED_PRICE_SUCCESS = "FETCH_CALCULATED_PRICE_SUCCESS";
export const FETCH_CALCULATED_PRICE_FAILURE = "FETCH_CALCULATED_PRICE_FAILURE";

export const SAVE_RESERVATION_STATE_DATA = "SAVE_RESERVATION_STATE_DATA";
export const SET_SELECTED_RESERVATION_DETAILS =
  "SET_SELECTED_RESERVATION_DETAILS";
export const updateReservationCheckout = (formData) => ({
  type: UPDATE_RESERVATION_CHECKOUT,
  payload: formData,
});
export const LOCATION_GATE_LIST_DATA = "LOCATION_GATE_LIST_DATA";
export const FETCH_GATELIST_REQUEST_FAILED = "FETCH_GATELIST_REQUEST_FAILED";
export const SET_SELECTED_GATES = "SET_SELECTED_GATES";
